<template>
  <div class="account-wrapper">
    <currency-settings />
  </div>
</template>
<script>
import { freshdeskMixin } from '@/mixins/Freshdesk'
import CurrencySettings from '@/components/account/CurrencySettings'

export default {
  components: { CurrencySettings },
  mixins: [freshdeskMixin],
  mounted() {
    this.$mpTrack('Currency Settings page mounted')
  }
}
</script>
<style lang="scss">
@import '../../assets/scss/palette';

.account-wrapper {
  padding-bottom: 50px;
  margin-top: 94px;
  .heading {
    font-size: 3rem;
    font-weight: bold;
    color: map-get($noble-blue, 500);
    margin-bottom: 2rem;
  }
  .account-tabs {
    label {
      &:hover {
        color: map-get($wealthy-green, 500);
      }
      background-color: white;
    }
    .btn-outline-primary {
      background: $noble-blue-100;
      color: $noble-blue-500;
      border-width: 1px;
      border-style: solid;
      border-color: $sky-blue-400 !important;
      border-radius: 8px 8px 0px 0px;
      border-top-right-radius: 8px !important;
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 19px;
      text-align: center;
      padding-left: 40px;
      padding-right: 40px;
      margin-right: 8px;
      &.active {
        background: $white;
        color: $noble-blue-500;
        border-bottom: 0px !important;
        margin-right: 8px;
        font-weight: 700;
      }
      &:focus {
        box-shadow: none !important;
      }
      &:active {
        color: $white;
        background-color: $sky-blue-400;
        border-color: $sky-blue-400;
      }
      &:hover {
        color: $white;
        background-color: $sky-blue-400;
        border-color: $sky-blue-400;
        box-shadow: none !important;
      }
    }
  }
  .tab-body {
    margin-top: 3rem;
  }
}
</style>
